import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix para los íconos de marcador de Leaflet en Vite
// (Vite maneja los assets diferente a Webpack/Metro)
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
  iconUrl:       new URL('leaflet/dist/images/marker-icon.png',    import.meta.url).href,
  shadowUrl:     new URL('leaflet/dist/images/marker-shadow.png',  import.meta.url).href,
});

interface WebReadOnlyMapProps {
  latitude: number;
  longitude: number;
  theme?: any;
}

export const WebReadOnlyMap = ({ latitude, longitude, theme }: WebReadOnlyMapProps) => {
  return (
    <div 
      className="h-[180px] rounded-xl overflow-hidden mt-3 border"
      style={{
        borderColor: theme?.background || '#E2E8F0',
      }}
    >
      <MapContainer
        center={{ lat: latitude, lng: longitude }}
        zoom={15}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
        zoomControl={true}
        dragging={true}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={{ lat: latitude, lng: longitude }} />
      </MapContainer>
    </div>
  );
};
